var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{staticClass:"mh-80",attrs:{"tag":"div","name":"page"}},[(!_vm.archiveMode)?_c('ActivePage',{key:"active"}):_c('ArchivePage',{key:"archive"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }